import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/letter`;

export default {
  async create(payload) {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/create`, payload);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async getLast() {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/last`);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
